/**
 * Parse a DD/MM/YYYY date string into a native Date object.
 * Returns null for empty, null, undefined, or dash values.
 */
export const parseDDMMYYYY = (val) => {
  if (!val || val === '-') return null;
  const [datePart] = String(val).trim().split(' ');
  const parts = datePart.split('/');
  if (parts.length !== 3) return null;
  const [dd, mm, yyyy] = parts;
  if (!dd || !mm || !yyyy) return null;
  const date = new Date(yyyy, mm - 1, dd);
  return isNaN(date.getTime()) ? null : date;
};

/**
 * Format a Date object as DD/MM/YYYY string.
 */
export const formatDDMMYYYY = (dateObj) => {
  if (!dateObj || isNaN(dateObj.getTime())) return '-';
  const dd = String(dateObj.getDate()).padStart(2, '0');
  const mm = String(dateObj.getMonth() + 1).padStart(2, '0');
  return `${dd}/${mm}/${dateObj.getFullYear()}`;
};

/**
 * Add (or subtract) days from a DD/MM/YYYY date string.
 * Returns a DD/MM/YYYY string, or null if input is invalid.
 */
export const addDaysDDMMYYYY = (dateStr, days) => {
  const date = parseDDMMYYYY(dateStr);
  if (!date) return null;
  date.setDate(date.getDate() + Number(days));
  return formatDDMMYYYY(date);
};

/**
 * MRT-compatible sorting function for DD/MM/YYYY date columns.
 * Nulls/empty values sort to the bottom.
 */
export const dateSortingFn = (rowA, rowB, columnId) => {
  const a = parseDDMMYYYY(rowA.getValue(columnId));
  const b = parseDDMMYYYY(rowB.getValue(columnId));
  if (!a && !b) return 0;
  if (!a) return 1;
  if (!b) return -1;
  return a - b;
};
